import { render, staticRenderFns } from "./ElacDevicesListDevice.vue?vue&type=template&id=983a67d8"
import script from "./ElacDevicesListDevice.vue?vue&type=script&lang=js"
export * from "./ElacDevicesListDevice.vue?vue&type=script&lang=js"
import style0 from "./ElacDevicesListDevice.vue?vue&type=style&index=0&id=983a67d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports